import { useCallback, useState, useMemo } from 'react';
import {
  getImportSourceOptions,
} from '../../../model';

export const useImportSourceState = ({
  logger,
  i18n,
  handleUsage,
}) => {
  const [importSource, setImportSource] = useState(null);

  const importSourceOptions = useMemo(() => getImportSourceOptions(i18n), [i18n]);

  const onImportSourceFilterChange = useCallback((newImportSource) => {
    if (importSource !== newImportSource) {
      setImportSource(newImportSource);
      logger.logTrace('onImportSourceFilterChange', { importSource: newImportSource });
      if (handleUsage) {
        handleUsage();
      }
    }
  }, [handleUsage, importSource, logger]);

  return {
    importSource,
    importSourceOptions,
    onImportSourceFilterChange,
  };
};
